// 高科技风背景动画 - 优化版，解决内存泄漏
let matrixRainInterval = null;
let resizeListener = null;
let addLightBeamInterval = null;

// 全局可调用的初始化和清理函数
window.initTechBackground = function() {
  // 先清理可能存在的旧实例
  window.cleanupTechBackground();
  
  const canvas = document.getElementById('matrix-rain');
  if (!canvas) return; // 如果元素不存在则退出

  const ctx = canvas.getContext('2d');
  if (!ctx) return; // 如果无法获取上下文则退出
  
  // 调整画布大小的函数
  const resizeCanvas = () => {
    if (canvas) {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }
  };
  
  // 初始设置画布大小
  resizeCanvas();
  
  // 注册新的resize事件监听器并保存引用以便后续清理
  resizeListener = resizeCanvas;
  window.addEventListener('resize', resizeListener);
  
  // AI去水印相关词汇，增加技术感
  const aiTerms = [
    '01', 'AI', 'ML', 'CV', 
    '像素', '消除', '水印', 
    'RGB', 'CNN', 'GAN', 
    '神经网络', '学习', '图像', 
    '去除', '处理', '分析',
    '图层', '修复', '转换'
  ];
  
  // 字符下落对象
  class Symbol {
    constructor(x, y, fontSize, canvasHeight) {
      this.characters = aiTerms[Math.floor(Math.random() * aiTerms.length)];
      this.x = x;
      this.y = y;
      this.fontSize = fontSize;
      this.canvasHeight = canvasHeight;
      this.opacity = Math.random() * 0.5 + 0.1;
      this.speed = Math.random() * 2 + 1;
    }
    
    draw(ctx) {
      // 使用渐变色，从青色到蓝色
      const gradient = ctx.createLinearGradient(0, 0, 0, 30);
      gradient.addColorStop(0, `rgba(0, 255, 255, ${this.opacity})`);
      gradient.addColorStop(1, `rgba(0, 128, 255, ${this.opacity})`);
      
      ctx.font = `${this.fontSize}px monospace`;
      ctx.fillStyle = gradient;
      ctx.fillText(this.characters, this.x, this.y);
      this.y += this.speed;
      
      if (this.y > this.canvasHeight) {
        this.y = 0;
        this.x = Math.random() * canvas.width;
        this.speed = Math.random() * 2 + 1;
        this.opacity = Math.random() * 0.5 + 0.1;
      }
    }
  }
  
  // 效果初始化
  class Effect {
    constructor(canvasWidth, canvasHeight) {
      this.canvasWidth = canvasWidth;
      this.canvasHeight = canvasHeight;
      this.fontSize = 16;
      this.columns = Math.floor(this.canvasWidth / this.fontSize);
      this.symbols = [];
      this.initialize();
    }
    
    initialize() {
      // 清空先前的符号
      this.symbols = [];
      
      for (let i = 0; i < this.columns; i++) {
        // 只在部分列创建符号，使效果不那么密集，提高性能
        if (Math.random() < 0.3) { // 减少到30%的密度
          const symbol = new Symbol(
            i * this.fontSize,
            Math.random() * this.canvasHeight,
            this.fontSize,
            this.canvasHeight
          );
          this.symbols.push(symbol);
        }
      }
    }
    
    render(ctx) {
      // 使用半透明黑色覆盖整个画布，形成拖尾效果
      ctx.fillStyle = 'rgba(10, 25, 47, 0.1)';
      ctx.fillRect(0, 0, this.canvasWidth, this.canvasHeight);
      
      // 渲染所有符号
      this.symbols.forEach(symbol => symbol.draw(ctx));
    }
    
    // 添加resize方法，用于当窗口大小变化时
    resize(width, height) {
      this.canvasWidth = width;
      this.canvasHeight = height;
      this.columns = Math.floor(this.canvasWidth / this.fontSize);
      this.initialize();
    }
    
    // 释放资源
    dispose() {
      this.symbols = [];
    }
  }
  
  // 创建效果实例
  const effect = new Effect(canvas.width, canvas.height);
  
  // 使用低频率setInterval，降低刷新率以减少资源占用
  matrixRainInterval = setInterval(() => {
    if (!canvas || !ctx) return; // 安全检查
    effect.render(ctx);
  }, 100); // 降低到10fps，进一步减少CPU使用
  
  // 添加光束效果
  function addLightBeam() {
    const lightBeam = document.querySelector('.light-beam');
    if (lightBeam) {
      const randomX = Math.random() * 100;
      const randomY = Math.random() * 100;
      lightBeam.style.top = `${randomY - 50}%`;
      lightBeam.style.left = `${randomX - 50}%`;
    }
  }
  
  // 减少光束更新频率，10秒一次
  addLightBeamInterval = setInterval(addLightBeam, 10000);
  
  // 初始调用一次光束效果
  addLightBeam();
  
  // 返回清理函数
  return () => {
    window.cleanupTechBackground();
  };
};

// 清理函数
window.cleanupTechBackground = function() {
  // 清理所有定时器
  if (matrixRainInterval) {
    clearInterval(matrixRainInterval);
    matrixRainInterval = null;
  }
  
  if (addLightBeamInterval) {
    clearInterval(addLightBeamInterval);
    addLightBeamInterval = null;
  }
  
  // 移除事件监听器
  if (resizeListener) {
    window.removeEventListener('resize', resizeListener);
    resizeListener = null;
  }
  
  // 清理Canvas
  const canvas = document.getElementById('matrix-rain');
  if (canvas) {
    const ctx = canvas.getContext('2d');
    if (ctx) {
      // 清空画布
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }
  }
};

// 页面可见性变化时的优化
document.addEventListener('visibilitychange', () => {
  if (document.hidden) {
    // 页面不可见时暂停动画，减少资源占用
    if (matrixRainInterval) {
      clearInterval(matrixRainInterval);
      matrixRainInterval = null;
    }
  } else if (!matrixRainInterval && window.initTechBackground) {
    // 页面再次可见时重新初始化
    window.initTechBackground();
  }
}, false);

// 仅在文档加载完成时初始化一次
document.addEventListener('DOMContentLoaded', () => {
  if (window.initTechBackground) {
    window.initTechBackground();
  }
}, { once: true });

// 在页面卸载时清理资源
window.addEventListener('beforeunload', () => {
  if (window.cleanupTechBackground) {
    window.cleanupTechBackground();
  }
}, { once: true }); 